"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _I18n = _interopRequireDefault(require("I18n"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _UISelectableButton = _interopRequireDefault(require("UIComponents/button/UISelectableButton"));

var _UIImage = _interopRequireDefault(require("UIComponents/image/UIImage"));

var _UIRibbon = _interopRequireDefault(require("UIComponents/ribbon/UIRibbon"));

var DynoTypeSelection = function DynoTypeSelection(_ref) {
  var labelI18nKey = _ref.labelI18nKey,
      imageSrc = _ref.imageSrc,
      selected = _ref.selected,
      onClick = _ref.onClick,
      isNew = _ref.isNew;
  return _react.default.createElement("div", {
    className: "dyno-type-selection m-bottom-8"
  }, _react.default.createElement(_UISelectableButton.default, {
    "data-type": _I18n.default.text(labelI18nKey),
    className: "m-bottom-2",
    block: true,
    onClick: onClick,
    selected: selected,
    textLabel: _react.default.createElement(_FormattedMessage.default, {
      message: labelI18nKey
    }),
    size: "large"
  }, isNew && _react.default.createElement(_UIRibbon.default, null, _react.default.createElement(_FormattedMessage.default, {
    message: 'leadFlowEditor.leadFlowTypeEditor.newBadge'
  })), _react.default.createElement(_UIImage.default, {
    src: imageSrc,
    alt: _I18n.default.text(labelI18nKey)
  })));
};

DynoTypeSelection.propTypes = {
  labelI18nKey: _react.PropTypes.string.isRequired,
  imageSrc: _react.PropTypes.string.isRequired,
  selected: _react.PropTypes.bool.isRequired,
  onClick: _react.PropTypes.func,
  isNew: _react.PropTypes.bool.isRequired
};
var _default = DynoTypeSelection;
exports.default = _default;
module.exports = exports.default;